export async function fileToBase64(
  file: File | Blob | string,
): Promise<string> {
  const extractBase64 = (dataUrl: string) => {
    const parts = dataUrl.split(",");
    return parts.length > 1 ? parts[1] : dataUrl;
  };

  if (file instanceof File || file instanceof Blob) {
    const dataUrl = await new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result));
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
    return extractBase64(dataUrl);
  }

  if (typeof file === "string") {
    return extractBase64(file);
  }

  return "";
}
